import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';

import {Typography, Button, makeStyles} from '@material-ui/core';
import styles from './styles';

import ErrorDialog from './ErrorDialog/ErrorDialog';
import {authGoogle, authGoogleWithCode, notified} from './services/actions';
import {redirectToFirstPage} from '../../utils';

const useStyles = makeStyles(styles);

interface Dispatch {
    authGoogle: typeof authGoogle;
    authGoogleWithCode: typeof authGoogleWithCode;
    notified: typeof notified;
}

export interface Props {
    authGoogle: typeof authGoogle;
    authGoogleWithCode: typeof authGoogleWithCode;
    notified: typeof notified;
    error: boolean;
}

export const Login = ({authGoogle, authGoogleWithCode, notified, error}: Props) => {
    const classes = useStyles();
    const location = useLocation();

    const auth = () => authGoogle();
    const closeErrorMessage = () => notified();

    useEffect(() => {
        const data = localStorage.getItem('accessToken');
        if (data) {
            redirectToFirstPage();
        } else if (location.search) {
            const {code} = queryString.parse(location.search);

            authGoogleWithCode(code);
        }
    }, []);

    if (error) {
        return (
            <div>
                <ErrorDialog open={error} close={closeErrorMessage} text={'You do not have access'} />
            </div>
        );
    }

    return (
        <div className={classes.wrapLogin}>
            <Typography align={'center'} variant="h4" color={'primary'} className={classes.title}>
                Quality Feedback System
            </Typography>
            <div className={classes.wrappBtn}>
                <Button variant="contained" color="secondary" className={classes.button} onClick={auth}>
                    <span className={classes.googleButton}>G+</span>
                    Sign In
                </Button>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    error: state.authReducer.error
});

const mapDispatchToProps: Dispatch = {
    authGoogle,
    authGoogleWithCode,
    notified
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
